export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },{
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_fabric_name') || '面料名称',
    field: 'fabricName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'fabricStatus',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_width_weight') || '门幅克重',
    field: 'widUnit',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'widUnit' },
  },
  {
    title: that.$l('table_label_fabric_content') || '面料成分',
    field: 'fabricContent',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricContent' },
  },
  {
    title: that.$l('table_label_yarn_count') || '纱支',
    field: 'yarnCount',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
]

